<script setup lang="ts">

import { Icon } from '@iconify/vue'
import './timeline_picker.scss'
import { computed, ref, watch } from 'vue'

interface TimelineProps {
  dataSet?: Array<any>
  value?: any
  editable?: boolean
}
const props = defineProps<TimelineProps>()
const emit = defineEmits(['update'])

const dataSet = ref(props.dataSet)

const value = computed(() => {
  return props.value
})

const editable = computed(() => {
  return props.editable
})


const handleClickTimeLine = (item: any) => {
  if(!editable.value) return false;

  const _dataSet = dataSet.value
  if( _dataSet && _dataSet.length > 0 ){
    let done = false;
    _dataSet.forEach((_item) => {
      if(!done){
        if(_item.id === item.id){
          done = true;
          _item.done = true;
        }else{
          _item.done = true;
        }
      } else{
        _item.done = false;
      }
    })
  }
  dataSet.value = _dataSet
  emit('update', item, _dataSet)
}


watch(()=>props.dataSet, ()=>{
  dataSet.value = props.dataSet
})
</script>

<template>
  <div :class="`timeline-picker ${editable ? 'timeline-picker-editable' : ''}`">
    <Timeline :value="dataSet" layout="horizontal" align="top">
      <template #marker="slotProps">
                <span :class="slotProps.item.done ? 'icon done' : 'icon'" @click="()=>handleClickTimeLine(slotProps.item)">
                  <Icon icon="icon-park-solid:check-one" />
                </span>
      </template>
      <template #content="slotProps">
        <span class="text-[12px]" @click="()=>handleClickTimeLine(slotProps.item)">{{ slotProps.item.label }}</span>
      </template>
    </Timeline>
  </div>
</template>

<style scoped>

</style>
